<template>
  <div class="login-container">
    <!-- 顶部导航栏 -->
    <div class="top-navbar">
      <div class="nav-content">
        <div class="nav-left">
          <el-image style="width: 150px;height: 25.5px" :src="logo"/>
        </div>
        <div class="nav-center">
          <span class="website">www.borunxinke.com</span>
          <span class="divider"></span>
          <div class="phone">400-655-0657</div>
        </div>
        <div class="nav-right">
          <div class="official-wechat">公司官微</div>
        </div>
        <el-image style="width: 45px;height: 45px" :src="homeCode"/>
      </div>
    </div>

    <!-- 轮播图区域 -->
    <div class="carousel-section">
      <el-carousel
        :interval="interval"
        v-if="initialLoad"
        ref="carousel"
        arrow="always"
        height="100vh"
        indicator-position="none"
        @change="handleSlideChange"
      >
        <el-carousel-item v-for="(item, index) in carouselItems" :key="index">
          <div class="carousel-item" :style="{ backgroundImage: `url(${item.image})` }">
            <div class="carousel-overlay"></div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <Verify @success="success" @closeBox="closeBox" mode="pop" captcha-type="blockPuzzle" ref="verify" :img-size="{width:'400px',height:'200px'}"></Verify>
      <!-- 右侧登录框 -->
      <div class="login-form-container">
        <div class="login-form">
          <div class="login-title">账号登录</div>
          <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="form-style">
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
                size="large"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                size="large"
                show-password
                @keyup.enter.native="handleLogin"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <Captcha @success="onVerifySuccess" :verified="verified"></Captcha>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="large"
                style="width: 100%;"
                @click="handleLogin"
                :loading="loading"
              >
                登录
              </el-button>
            </el-form-item>
          </el-form>

          <div class="login-links">
            <span class="find-password" @click="handleFindPassword">找回密码</span>
            <!--            <span class="divider">|</span>-->
            <!--            <span class="police-query" @click="handlePoliceQuery">公安查询</span>-->
          </div>
        </div>
      </div>
      <div class="text-div">
        <div>增值电信业务经营许可证：吉B2-20160135、吉B2-20160126</div>
        <div style="display: flex;justify-content: center;margin-top: 2px;">© 2009-2025 borunxinke.com 版权所有 <span style="margin-left: 15px;margin-right: 15px;">吉ICP备16004968号-3</span> <div style="margin-right: 5px;"><el-image style="width: 16px;height: 16px;" :src="gongan"/></div>吉公网安备：22010202000714</div>
      </div>
    </div>
    <!-- 验证弹窗 -->
    <VerifyIdentityDialog
      :visible="verifyDialogVisible"
      @verify-success="onDialogSuccess"
      @close="onDialogClose"
    />
    <!-- 底部版权信息 -->
    <div class="footer">
      <div class="footer-content">
      </div>
    </div>
  </div>
</template>

<script>
// import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import Captcha from "../components/verifition/Captcha"
import Verify from "../components/verifition/Verify"
import VerifyIdentityDialog from "../components/verifition/VerifyIdentityDialog"
import index from "./Index";
export default {
  name: 'LoginPage',
  components: {
    Verify,
    Captcha,
    VerifyIdentityDialog
  },
  data() {
    return {
      carouselItems: [
        {
          image: require('@/assets/images/home1.jpg'),
          title: "驿站在手 业绩无忧"
        },
        {
          image: require('@/assets/images/home2.jpg'),
          title: "便民服务 高效管理"
        },
        {
          image: require('@/assets/images/home3.jpg'),
          title: "智能驿站 科技便民"
        }
      ],
      logo: require('@/assets/images/logo.png'),
      homeCode: require('@/assets/images/home_code.jpg'),
      gongan: require('@/assets/images/gongan.png'),
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      params: {},
      verified: 1,
      loading: false,
      currentSlide: 0,
      interval: 5000,
      initialLoad: true,
      verifyDialogVisible: false
    }
  },
  mounted () {
    // this.preloadImages().then(() => {
    //   this.initialLoad = true
    //   this.$refs['carousel'].updateItems() // 强制重新计算轮播项
    // })
  },
  methods: {
    preloadImages () {
      const promises = this.carouselItems.map(item => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = item.image
          img.onload = resolve
          img.onerror = resolve // 即使失败也继续
        })
      })
      return Promise.all(promises)
    },
    onVerifySuccess() {
      this.verified = 2
      this.$refs.verify.show()
    },
    closeBox () {
      this.verified = 1
    },
    success (params) {
      this.params = params
      this.verified = 3
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },
    handleSlideChange (index) {
      // if (this.initialLoad) {
      //   this.initialLoad = false;
      //   this.$refs.carousel.setActiveItem(0); // 重置确保时序准确
      // }
      this.currentSlide = index
    },
    handleLogin () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (Object.keys(this.params).length === 0) {
            this.$message('请先点击按钮进行验证')
            return
          }
          this.submitLogin()
        }
      })
    },
    submitLogin () {
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        target: '.main',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, .7)'
      })
      var p1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postMerCheckLogin2Bank,
        // this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        {"Content-Type": "application/json"},
        {username:this.loginForm.username,password:this.customGlobal.md5(this.loginForm.password),captcha: this.params.captchaVerification})
      p1.then((res) => {
        if(res.data.authstatus=='success'){
          let heat_permission = [];
          let heat_buttonn = [];
          let platfrom_permisson = [];
          let platfrom_button = [];
          let menu = JSON.parse(res.data.menu);
          if(menu.hasOwnProperty("heatconfig")){//热力账号
            if(menu.heatconfig.hasOwnProperty("permissionconfig")){
              heat_permission = menu.heatconfig.permissionconfig.detail;
            }else if(menu.heatconfig.hasOwnProperty("buttonconfig")){
              heat_buttonn = menu.heatconfig.buttonconfig.detail;
            }
          }
          if(menu.hasOwnProperty("platfromconfig")){//平台账号
            if(menu.platfromconfig.hasOwnProperty("permissionconfig")){
              platfrom_permisson = menu.platfromconfig.permissionconfig.detail;
            }else if(menu.platfromconfig.hasOwnProperty("buttonconfig")){
              platfrom_button = menu.platfromconfig.buttonconfig.detail;
            }
          }
          platfrom_permisson = platfrom_permisson.concat(heat_permission);
          platfrom_button = platfrom_button.concat(heat_buttonn);
          console.info("platfrom_permisson:"+JSON.stringify( platfrom_permisson) );
          //console.info("heat_permission:"+JSON.stringify( heat_permission) );
          //菜单
          this.customGlobal.userMenuForPermission = platfrom_permisson;
          this.customGlobal.userMenuForButton = platfrom_button;

          this.parseMenu( JSON.stringify(platfrom_permisson) );
          this.customGlobal.userInfo =  {username:res.data.owner_uuid,authed:"success"};

          //用户信息
          this.customGlobal.userInfoExt =  JSON.parse(res.data.userInfo);
          this.customGlobal.userInfoExt.company_id=res.data.company_id
          this.customGlobal.userInfoExt.company_name=res.data.company_name
          this.customGlobal.userInfoExt.company_id13=res.data.company_id13
          this.customGlobal.userMenu = JSON.parse(res.data.menu);
          this.customGlobal.systemDictionary = JSON.parse(res.data.dic);
          //权限点
          this.customGlobal.permissionKeyOrganKey = {permissionkey:JSON.parse(res.data.permissionkey),orgkey:JSON.parse(res.data.orgkey),btnkey:JSON.parse(res.data.btnkey)};
          //机构模板
          this.customGlobal.userOrgan = JSON.parse(res.data.organ);
          loading.close();
          window.sessionStorage.setItem('userInfo',this.customGlobal.encrypt(JSON.stringify(this.customGlobal.userInfo),this.customGlobal.cryptoKey) );
          window.sessionStorage.setItem('userMenu',this.customGlobal.encrypt(JSON.stringify(this.customGlobal.userMenu),this.customGlobal.cryptoKey) );
          window.sessionStorage.setItem('userInfoExt',this.customGlobal.encrypt(JSON.stringify(this.customGlobal.userInfoExt),this.customGlobal.cryptoKey));
          window.sessionStorage.setItem('userMenuForPermission',this.customGlobal.encrypt(JSON.stringify(this.customGlobal.userMenuForPermission),this.customGlobal.cryptoKey) );
          window.sessionStorage.setItem('userMenuForButton',this.customGlobal.encrypt(JSON.stringify(this.customGlobal.userMenuForButton),this.customGlobal.cryptoKey) );
          window.sessionStorage.setItem('systemDictionary',this.customGlobal.encrypt(JSON.stringify(this.customGlobal.systemDictionary),this.customGlobal.cryptoKey) );
          window.sessionStorage.setItem('permissionKeyOrganKey',this.customGlobal.encrypt(JSON.stringify(this.customGlobal.permissionKeyOrganKey),this.customGlobal.cryptoKey) );
          window.sessionStorage.setItem('userOrgan',this.customGlobal.encrypt(JSON.stringify(this.customGlobal.userOrgan),this.customGlobal.cryptoKey) );
          this.$router.push({path:'/index?isdl=1'})
        }else{
          console.info("认证失败");
          loading.close();

          this.params = {}
          this.verified = 1
          this.$alert(res.data.msg, '认证失败', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }

      },error=>{
        console.log("异步调用出错:"+JSON.stringify(error));
        loading.close();

        this.$alert(JSON.stringify(error.message), '认证出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:"+JSON.stringify(res));
        loading.close();


        this.$alert(JSON.stringify(res.message), '认证出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        })
      })
    },
    parseMenu:function (e){
      let _children_ = new Array();
      let _parentRoute_ = {};

      let menus = JSON.parse(e) ;

      for(let i1=0;i1< menus.length;i1++){

        if (!menus[i1].detail) {
          continue
        }
        for(let i2=0;i2< menus[i1].detail.length;i2++){
          // console.info("url:"+menus[i1].detail[i2].url);
          _children_.push(
            {
              name : menus[i1].detail[i2].url ,
              path : menus[i1].detail[i2].url ,

              //注意全路径
              component: () => import('@/components' + menus[i1].detail[i2].vue)
            }
          );
        }
      }
      //增加额外业务路由
      _children_.push(
        {
          name:'org_query1',
          path: '/org_query1',
          component: () => import('@/components/index/right/Example4.vue' )//将组件用require引进来
        });
      _children_.push(
        {
          name:'org_query',
          path: '/org_query',
          component: () => import('@/components/views/orgInfoManager/OrgInfoCenter.vue' )//将组件用require引进来
        });
      _children_.push(
        {
          name:'org_query_bank',
          path: '/org_query_bank',
          component: () => import('@/components/views/bankPlatform/orgInfo/OrgInfoCenterBank.vue' )//将组件用require引进来
        });
      _children_.push(
        {
          name:'org_query_bank2',
          path: '/org_query_bank2',
          component: () => import('@/components/views/bankPlatform/orgInfo/OrgInfoCenterBank2.vue' )//将组件用require引进来
        });
      _children_.push(
        {
          name:'device_query',
          path: '/device_query',
          component: () => import('@/components/views/deviceManager/DeviceInfoCenter.vue' )//将组件用require引进来
        });
      _parentRoute_=
        {
          name : "index",
          path : "/index",
          component : index,
          children : _children_
        };
      let dtRouter = [_parentRoute_];
      this.$router.addRoutes(dtRouter);
    },
    handleFindPassword () {
      this.verifyDialogVisible = true
    },
    onDialogClose () {
      this.verifyDialogVisible = false
    },
    onDialogSuccess (userData) {
      console.log('验证成功', userData)
      // 处理验证成功后的逻辑
    },
    handlePoliceQuery() {
      this.$message.info('公安查询功能');
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  overflow: hidden;
  position: relative;
}

/* 顶部导航栏样式 */
.top-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: rgba(255, 255, 255, 0.95);
  z-index: 1000;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 30px 0 10px;
  margin: 0 auto;
}

.nav-left {
  display: flex;
  width: 65%;
}

.nav-center {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  color: #666;
  font-size: 14px;
}
.phone {
  min-width: 150px;
  text-align: right;
}
.nav-center .divider {
  color: #ddd;
}

.nav-right {
  /*position: relative;*/
  /*cursor: pointer;*/
}

.official-wechat {
  /*color: #409EFF;*/
  text-align: right;
  min-width: 100px;
  font-size: 14px;
}

/*.qrcode-tooltip {*/
/*  position: absolute;*/
/*  top: 30px;*/
/*  right: 0;*/
/*  width: 100px;*/
/*  height: 100px;*/
/*  background: white;*/
/*  border-radius: 8px;*/
/*  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);*/
/*  opacity: 0;*/
/*  visibility: hidden;*/
/*  transition: all 0.3s;*/
/*}*/

/*.nav-right:hover .qrcode-tooltip {*/
/*  opacity: 1;*/
/*  visibility: visible;*/
/*  top: 40px;*/
/*}*/

.qrcode-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

/* 轮播图区域样式 */
.carousel-section {
  height: 100vh;
  position: relative;
}

.carousel-item {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /*background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%);*/
}

/* 登录框样式 */
.login-form-container {
  position: absolute;
  top: 56%;
  right: 10%;
  transform: translateY(-50%);
  z-index: 100;
}

.login-form {
  width: 220px;
  padding: 10px;
  background: linear-gradient(to bottom,
  rgba(224, 224, 224, 0.5) 0%,
  rgba(224, 224, 224, 0.5) 14%,
  rgba(255, 255, 255, 0.9) 14%,
  rgba(255, 255, 255, 0.95) 100%
  );
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
}

.login-title {
  text-align: center;
  color: #333;
  font-size: 20px;
}
.form-style {
  margin-top: 30px;
}

.login-links {
  text-align: right;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.login-links span {
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s;
}

.login-links span:hover {
  color: #409EFF;
}

.login-links .divider {
  margin: 0 10px;
  color: #ddd;
}
.text-div {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 0;
  z-index: 100;
  color: #000000;
  font-size: 11px;
}
/* 底部版权信息 */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  padding: 3px 0;
  z-index: 100;
}

.footer-content {
  text-align: center;
  color: #666;
  font-size: 12px;
  line-height: 1.6;
}

/* 轮播图箭头样式自定义 */
.el-carousel__arrow {
  width: 50px;
  height: 50px;
  font-size: 20px;
  background-color: rgba(255, 255, 255, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.5);
}

.el-carousel__arrow:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.el-icon-arrow-left, .el-icon-arrow-right {
  color: #333;
  font-weight: bold;
}
.verified-text {
  color: #67C23A;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue